import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { blogPost } from '../../../Models/Session';
import { BaseApiService } from '../../../Services/base-api.service';


@Component({
  selector: 'app-blog-post-detail',
  templateUrl: './blog-post-detail.component.html',
  styleUrls: ['./blog-post-detail.component.css'],standalone:false
})
export class BlogPostDetailComponent implements OnInit{

  itemId:any;
  posts!:blogPost
  sessionDataArray: blogPost[] = [];
  loading:boolean=false;
  constructor
  (
    private api:BaseApiService,
    private http:HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private messageService:MessageService,


  )
  {

  }

  isLegalPage(): boolean {
    return (
      this.posts?.title?.includes('Privacy') ||
      this.posts?.title?.includes('Terms') ||
      this.posts?.title?.includes('Disclaimer')
    );
  }

  getdat(id:any){
    this.loading=true;
    this.api.read(`Blog/${id}`).subscribe
    (
      (response)=>{
        this.posts = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }

  getdata(){
    this.loading=true;
    this.api.read("Blog").subscribe
    (
      (response)=>{
        this.sessionDataArray = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.itemId = params['id'];
      this.getdat(this.itemId);
    });
    this.getdata();

  }
}
